import { CorrectionActions } from "@/_models/task.interface";
import { DateUtils } from "@/_utility/DateTimeFormat";
import { CombinedTaskCardMobileComponent } from "@/components/shared/flight-list/combined-task-card-mobile/combined-task-card-mobile.component";
import { SharedComponentsModule } from "@/components/shared/shared-components.module";
import { Component, Input, OnInit } from "@angular/core";

@Component({
    selector: "app-task-card",
    standalone: true,
    imports: [SharedComponentsModule, CombinedTaskCardMobileComponent],
    templateUrl: "./task-card.component.html",
    styleUrls: [
        "./task-card.component.scss",
        "../home-task-card/home-task-card.component.scss",
    ],
})
export class TaskCardComponent implements OnInit {
    @Input() task: CorrectionActions;
    @Input() showEdit: boolean = false;

    constructor(public dateUtils: DateUtils) {}

    ngOnInit() {
        // Initialization logic here
    }
}
